import { FC, ReactNode } from "react";
import { ListingContextProvider } from "./use-listings";

type SubscriptionContentProviderProps = {
  children: ReactNode
}

/**
 * SubscriptionContentProvider
 *
 * Provides access to premium features based on user subscription tier.
 *
 * Design Decision: ListingContextProvider is ALWAYS rendered, even for Basic users.
 * This allows downgraded users to VIEW their existing listings/sales data in read-only mode.
 *
 * Write operations (create, edit, delete) are restricted at the component level using:
 * - useSubscriptionTooling().hasAccess() checks
 * - Disabled buttons/forms for Basic users
 * - SubscriptionBanner showing upgrade prompts
 */
export const SubscriptionContentProvider: FC<SubscriptionContentProviderProps> = ({ children }) => {
  return (
    <ListingContextProvider>
      {children}
    </ListingContextProvider>
  )
}
